import styles from "../Phone.module.scss";
import { usePrefersReducedMotion } from "../../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import { useVideoPlayback } from "../../../hooks/useVideoPlayback";
import { JumpScare } from "./JumpScare.component";

interface IntroSlideProps {
  openingAnimationComplete: boolean;
  splashScreenComplete: boolean;
  isActive: boolean;
}

export const IntroSlide = ({
  openingAnimationComplete,
  splashScreenComplete,
  isActive,
}: IntroSlideProps) => {
  const { prefersReducedMotion } = usePrefersReducedMotion();
  const { forceFallback, videoRef } = useVideoPlayback({ isActive });

  return (
    <div data-slide-id="introSlide" className={styles.phoneSlide}>
      {openingAnimationComplete && !splashScreenComplete && (
        <>
          {prefersReducedMotion || forceFallback ? (
            <img
              src="/splash-screen-still.jpg"
              alt=""
              className={styles.assetStyles}
            />
          ) : (
            <video
              ref={videoRef}
              className={styles.assetStyles}
              preload="auto"
              autoPlay
              muted
              playsInline
            >
              <source src="/splash_screen.mp4" type="video/mp4" />
            </video>
          )}
        </>
      )}

      {splashScreenComplete && <JumpScare isActive={isActive} />}
    </div>
  );
};
